/**
 * package: com.inq.stage
 * class: ViewportMgrImplAndroid2
 * @extends com.inq.stage.ViewportMgrImplPhoneAndroid
 * @constructor
 */
com.inq.stage.ViewportMgrImplPhoneAndroid_2 = function() {
	com.inq.stage.ViewportMgrImplPhoneAndroid.call(this);
};
/* specify hierary; its parent is com.inq.stage.ViewportMgrImplPhoneAndroid */
$hxClasses.extend(com.inq.stage.ViewportMgrImplPhoneAndroid, com.inq.stage.ViewportMgrImplPhoneAndroid_2, 'com.inq.stage.ViewportMgrImplPhoneAndroid_2');


/**
 * getInitialWidth
 * This overrides parent's function.
 *
 * $type TFun([],TInst(Int,[]))
 * @override
 * @private
 * @this com.inq.stage.ViewportMgrImplPhoneAndroid_2
 * @return {number}
 */
com.inq.stage.ViewportMgrImplPhoneAndroid_2.prototype.getInitialWidth = function() {
	this.createViewportElement("");/* Create a bogus empty viewport for now to fix the "position fixed" problem in android 2.x */
	/** @type {number} */
	var iw = this.clientWindow.document.body.clientWidth;
	/** @type {number} */
	var innerWidth = this.clientWindow.innerWidth;
	/** @type {Element} */
	var testDiv = this.clientDocument.createElement("DIV");
	testDiv.style.cssText = "position: fixed; top: 3px; left: 3px; right: 3px; bottom: 3px; background-color: red; display: block;";
	testDiv.id = "tcChat_TestDiv";
	this.clientDocument.body.appendChild(testDiv);
	/** @type {number} */ 
	var divWidth = testDiv.clientWidth;
	this.clientWindow.alert("body width is " + iw + "\n" + "div width is " + divWidth + "\n" + "inner width is " + innerWidth);
	this.clientDocument.body.removeChild(testDiv);
	
	return iw;
};


/** @type {com.inq.stage.ViewportMgrImplPhoneAndroid_2} */
com.inq.stage.ViewportMgrImplPhoneAndroid_2.prototype.__class__ = com.inq.stage.ViewportMgrImplPhoneAndroid_2;
